import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";

const COPY = {
  booking: {
    eyebrow: "BOOKING REQUEST RECEIVED",
    title: "Your date is in.",
    body: "We received your event details. Fotos on the Geaux will follow up using the contact information you provided to confirm availability, scope, and next steps.",
    cta: "BACK TO FOTOS",
    href: "/home",
  },
  waitlist: {
    eyebrow: "YOU'RE ON THE LIST",
    title: "We got you.",
    body: "Your signup is confirmed. We’ll use the information you provided to keep you posted about the next Pole & Polaroids drop.",
    cta: "BACK TO THE EXPERIENCE",
    href: "/",
  },
  partner: {
    eyebrow: "PARTNER INQUIRY RECEIVED",
    title: "Let’s build something.",
    body: "Your partnership inquiry is in. We’ll review the details and follow up using the contact information you provided.",
    cta: "BACK TO FOTOS",
    href: "/home",
  },
};

export default function ConversionSuccess({ type = "booking" }) {
  const content = COPY[type] || COPY.booking;
  return (
    <div className="flex min-h-screen min-w-0 items-center justify-center bg-[#070707] px-4 py-14 text-[#f5f0e7] sm:px-5 sm:py-16">
      <Seo
        title="Request Received | Fotos on the Geaux"
        description="Fotos on the Geaux confirmation page."
        path={window.location.pathname}
        robots="noindex,nofollow"
      />
      <main className="w-full max-w-2xl text-center">
        <CheckCircle2 size={58} className="mx-auto text-[#c8aa82]" />
        <p className="mt-7 font-accent text-[11px] tracking-[.34em] text-[#c8aa82]">{content.eyebrow}</p>
        <h1 className="mt-4 font-display text-5xl font-black tracking-[-.04em] sm:text-7xl">{content.title}</h1>
        <p className="mx-auto mt-6 max-w-xl text-base leading-7 text-white/60">{content.body}</p>
        <Link
          to={content.href}
          className="mt-9 inline-flex rounded-full border border-white/20 px-7 py-3 font-accent text-[11px] tracking-[.2em] transition hover:border-[#c8aa82] hover:text-[#c8aa82]"
        >
          {content.cta}
        </Link>
        <p className="mt-10 text-xs text-white/30">You might forget the night. You won’t forget the foto.</p>
      </main>
    </div>
  );
}
